/**
 * @generated SignedSource<<9f4958265933ee1a1c488bdf9833b955>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedContactDealerWrapper_item";
};
export type SharedContactDealerWrapper_item$key = {
  readonly " $data"?: SharedContactDealerWrapper_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b287b519943c0dcd775212c31d2e22e0";

export default node;
